"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reddit-editor-overlay",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('cancel');
      }
    }
  }, [_c('div', {
    staticClass: "reddit-editor-card"
  }, [_c('div', {
    staticClass: "editor-header"
  }, [_c('h2', [_vm._v("Crear una publicación")]), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._m(0), _c('div', {
    staticClass: "editor-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.postData.title,
      expression: "postData.title"
    }],
    staticClass: "title-input",
    attrs: {
      "type": "text",
      "placeholder": "Título de la publicación"
    },
    domProps: {
      "value": _vm.postData.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.postData, "title", $event.target.value);
      }
    }
  }), _vm._m(1), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.postData.text,
      expression: "postData.text"
    }],
    staticClass: "content-area",
    attrs: {
      "placeholder": "Escribe tu publicación aquí..."
    },
    domProps: {
      "value": _vm.postData.text
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.postData, "text", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "price-section"
  }, [_c('label', [_vm._v("Precio de acceso (opcional)")]), _c('div', {
    staticClass: "price-input-wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.postData.price,
      expression: "postData.price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "0.00 (Grátis si es 0)",
      "step": "0.01"
    },
    domProps: {
      "value": _vm.postData.price
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.postData, "price", $event.target.value);
      }
    }
  })]), _c('p', {
    staticClass: "price-info"
  }, [_vm._v("Si defines un precio, la publicación aparecerá bloqueada para no suscriptores hasta que paguen.")])])]), _c('div', {
    staticClass: "editor-footer"
  }, [_vm._m(2), _c('div', {
    staticClass: "footer-main"
  }, [_c('button', {
    staticClass: "cancel-btn",
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("CANCELAR")]), _c('button', {
    staticClass: "post-btn",
    attrs: {
      "disabled": !_vm.postData.title || !_vm.postData.text
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v(" PUBLICAR ")])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "editor-tabs"
  }, [_c('div', {
    staticClass: "tab item active"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Post")]), _c('div', {
    staticClass: "tab item"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" Imágenes & Video")]), _c('div', {
    staticClass: "tab item"
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" Link")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rich-toolbar"
  }, [_c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-bold"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-italic"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-strikethrough"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-superscript"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _c('div', {
    staticClass: "divider"
  }), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  })]), _c('button', {
    staticClass: "tool"
  }, [_c('i', {
    staticClass: "fa fa-quote-left"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer-tags"
  }, [_c('button', {
    staticClass: "tag-btn"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Spoiler")]), _c('button', {
    staticClass: "tag-btn"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" NSFW")])]);
}];